/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Protocol used to reach the container.
 *
 * @remarks
 */
export const EnvironmentUpstreamProtocol = {
  Http1: "http1",
  H2c: "h2c",
} as const;
/**
 * Protocol used to reach the container.
 *
 * @remarks
 */
export type EnvironmentUpstreamProtocol = ClosedEnum<
  typeof EnvironmentUpstreamProtocol
>;

/** @internal */
export const EnvironmentUpstreamProtocol$inboundSchema: z.ZodNativeEnum<
  typeof EnvironmentUpstreamProtocol
> = z.nativeEnum(EnvironmentUpstreamProtocol);
/** @internal */
export const EnvironmentUpstreamProtocol$outboundSchema: z.ZodNativeEnum<
  typeof EnvironmentUpstreamProtocol
> = EnvironmentUpstreamProtocol$inboundSchema;
